import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, normalizeStyle as _normalizeStyle, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "dt__filter-content-header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("span", null, "Фильтры", -1 /* HOISTED */)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("rect", {
  x: "0.000244141",
  y: "1.41406",
  width: "2",
  height: "16",
  rx: "1",
  transform: "rotate(-45 0.000244141 1.41406)",
  fill: "#CCCCCC"
}, null, -1 /* HOISTED */)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("rect", {
  x: "11.3137",
  width: "2",
  height: "16",
  rx: "1",
  transform: "rotate(45 11.3137 0)",
  fill: "#CCCCCC"
}, null, -1 /* HOISTED */)
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = { class: "dt__filter-content-wrapper-item" }
const _hoisted_7 = { class: "dt__filter-selfFooterBlock" }
const _hoisted_8 = {
  key: 0,
  class: "dt__filter-content-selectBlock"
}
const _hoisted_9 = { class: "dt__filter-content-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass($data.visible ? 'dt__filter-overlay' : '')
    }, null, 2 /* CLASS */),
    _createElementVNode("div", {
      class: _normalizeClass([[$data.visible ? 'show-filter' : ''], "dt__filter-content"])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _hoisted_2,
        (_openBlock(), _createElementBlock("svg", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (this.onClose && this.onClose(...args))),
          width: "13",
          height: "13",
          viewBox: "0 0 13 13",
          fill: "none",
          xmlns: "http://www.w3.org/2000/svg"
        }, _hoisted_5))
      ]),
      _createElementVNode("div", {
        class: "dt__filter-content-wrapper",
        style: _normalizeStyle(!this.hasValue ? 'height: calc(100vh - 118px)' : '')
      }, [
        _createElementVNode("div", _hoisted_6, [
          _createCommentVNode(" filters"),
          _renderSlot(_ctx.$slots, "filters")
        ])
      ], 4 /* STYLE */),
      _createElementVNode("div", _hoisted_7, [
        (this.hasValue)
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.onClear && $options.onClear(...args))),
                class: "dt__filter-content-selectBlock-clear"
              }, "Сбросить"),
              _renderSlot(_ctx.$slots, "active")
            ]))
          : _createCommentVNode("v-if", true),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("button", {
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => ($options.onApply && $options.onApply(...args))),
            class: "button button-primary button-xxs"
          }, "Применить")
        ])
      ])
    ], 2 /* CLASS */)
  ], 64 /* STABLE_FRAGMENT */))
}